import { render, staticRenderFns } from "./ThreadCompactHeader.vue?vue&type=template&id=3b693f80&scoped=true&"
import script from "./ThreadCompactHeader.vue?vue&type=script&lang=js&"
export * from "./ThreadCompactHeader.vue?vue&type=script&lang=js&"
import style0 from "./ThreadCompactHeader.vue?vue&type=style&index=0&id=3b693f80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b693f80",
  null
  
)

export default component.exports